export const isNotNullOrUndefined = <T>(item: T | null | undefined): item is T => {
  return item !== null && item !== undefined
}

export const flatten = <T>(arr: T[][]) => {
  const newArr: T[] = []
  return newArr.concat(...arr)
}

export const findNullProperties = <T>(
  obj: T,
  mandatory: string[],
  skip: string[] | null = null
): string[] => {
  const nullProperties: string[] = []

  for (let i = 0; i < mandatory.length; i++) {
    const mandatoryField = mandatory[i]
    try {
      if (skip != null && skip.includes(mandatoryField)) {
        continue
      }
      if (!Object.hasOwnProperty.call(obj, mandatoryField)) {
        nullProperties.push(mandatoryField)
        continue
      }

      const propertyValue = (obj as any)[mandatoryField]
      if (propertyValue === null) {
        nullProperties.push(mandatoryField)
      }
    } catch {
      nullProperties.push(mandatoryField)
    }
  }
  return nullProperties
}
